// @flow
import styled from "styled-components"

export const StyledSVG = styled.svg`
  text {
    font-weight: 500;
    text-transform: uppercase;
    font-size: 1.3rem;
    letter-spacing: 0.08rem;
  }
`



// WEBPACK FOOTER //
// ./src/assets/icons/PlanIcon/styled.js